import { useEffect, useState } from 'react';
import { Divider, Modal, Checkbox, Space } from 'antd';
import { BaseButton, FillButton } from 'components/elements';
import { IconSetting } from 'components/assets/icons';
import {putListSettingAPI} from 'api/common'

export function GridSetting({ colList=null, fnUpdateCol }) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState([]);

  const fnInit = () => {
    setOptions(colList?.filter(it => it.LIST_STATUS !== 2).map(it => ({label: it.LIST_ITEM_NAME, value: it.MENU_ITEM_IDX})))
    setValue(colList?.filter(it => it.LIST_STATUS === 1).map(it => it.MENU_ITEM_IDX))
  }

  const fnClose = () => {
    fnInit()
    setOpen(false)
  }

  const fnApply = async () => {
    const data = {
      menu_table_item_idx: options.map(it => it.value),
      column_status: options.map(it => value.includes(it.value) ? 1 : 0)
    }
    await putListSettingAPI(data)
    .then(res => {
      console.log(res)
      if (res.status === 200) {
        const { data_list } = res?.data
        fnUpdateCol(data_list)
        alert('적용완료')
        setOpen(false)
      }
    })
  }

  const fnCheckAll = (e) => {
		if (e.target.checked) {
			setValue(options.map(it => it.value))
		} else {
			setValue([])
		}
	}

  useEffect(()=>{
    fnInit()
  },[colList])


  return (
    <>
      <BaseButton padding='4px 0px' label='표 설정' text icon={<IconSetting />} onClick={() => setOpen(true)} /> 

      <Modal
        title={<div className='layout-title-label'>표 설정</div>}
        open={open}
        onCancel={fnClose}
        footer={() => 
          <Space>
            <BaseButton key={'close'} label={'초기화'} onClick={fnInit} />
            <FillButton key={'set'} label={'적용하기'} onClick={fnApply} />
          </Space>
        }
      >
        확인하고 싶은 항목을 추가해주세요
        <Divider />
        <Checkbox checked={options?.length === value?.length} onChange={fnCheckAll} >
          전체선택
        </Checkbox>
        <Divider className='divider' />
        <Checkbox.Group options={options} value={value} onChange={setValue} />
      </Modal>
    </>
  )
}
